import { useEffect } from "react";
import Navbar from "../../../../shared/components/navbar";
import Footer from "../../../../shared/components/footer";
import PageContent from "../../../../shared/components/PageContent";
import AllSupportSteps from "./allSupportSteps";
import { useSearchParams } from "react-router-dom";
import CancellationDisclaimer from "../../components/support/CancellationDisclaimer";
import ChangeDisclaimer from "../../components/support/ChangeDisclaimer";
import SupportStep from "../../enums/SupportStep";
import useAppStateStore from "../../../../shared/store/AppStateStore";
import QuoteStepLoader from "../../../../shared/components/QuoteStepLoader";
import useSupportStore from "../../store/supportStore";

const Support = () => {
  const STATE = useAppStateStore();

  const [searchParams] = useSearchParams();
  const supportType = searchParams.get("supportType");

  const policyNumber =
    STATE.customerPolicies?.customerPolicies?.[0]?.policyNumber;

  useEffect(() => {
    if (policyNumber) {
      useSupportStore.getState().updateField("policyNumber", policyNumber);
    }
  }, [policyNumber]);

  useEffect(() => {
    if (supportType === "cancelPolicy") {
      STATE.setSelectedOptions([
        { id: SupportStep.SP_CANCELLATION, title: "Cancellation" },
      ]);
      STATE.setSpCurrentStep(SupportStep.SP_CANCELLATION);
    }
  }, []);

  return (
    <div className="tw-flex tw-min-h-screen tw-flex-col tw-text-dis-base tw-leading-[1.5] tw-text-dis-text-2 [&_*]:tw-box-border">
      <Navbar />
      <PageContent>
        {STATE.supportLoading ? (
          <QuoteStepLoader
            title="Submitting your request"
            description="We're sending your change or cancellation details."
            message="Please wait while we submit your request."
          />
        ) : (
          <>
            <AllSupportSteps />
            {STATE.isCancellationModalOpen && <CancellationDisclaimer />}
            {STATE.isChangeModalOpen && <ChangeDisclaimer />}
          </>
        )}
      </PageContent>
      <Footer />
    </div>
  );
};

export default Support;
